import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-first-form',
  templateUrl: './first-form.component.html',
  styleUrls: ['./first-form.component.scss']
})
export class FirstFormComponent {
  @Input() storeTeamForm: UntypedFormGroup;
  @Input() organizationArray:any[] = [];
  @Input() states: any[] = [];
  @Input() markets: any[] = [];
  @Input() selectedOrganization: any = null;
  @Input() selectedmarket: any = null;
  @Output() organizationSelect: EventEmitter<any> = new EventEmitter();
  @Output() emailSelect: EventEmitter<any> = new EventEmitter();

  @Output() marketSelect: EventEmitter<any> = new EventEmitter();
  @Output() nextEvent: EventEmitter<any> = new EventEmitter();
  @Input() searchText: any = ''
  @Input() searchTextMark: string;
  isLoggedIn: boolean;

  ngOnInit() {
    const isLoggedInUser = JSON.parse(localStorage.getItem('user'));
    if (isLoggedInUser?.roles[0]?.name == "ENDUSER") {
      this.isLoggedIn =true
      this.storeTeamForm.patchValue({ Email: isLoggedInUser.email })
      this.storeTeamForm.get('Email')?.disable();
      this.onChangeEmail()
    }

  }
  splitName(name: string): string[] {
    if (!this.searchText) return [name];
    const parts = name.split(new RegExp(`(${this.searchText})`, 'gi'));
    return parts.filter(part => part.trim() !== "");
  }

  splitNameMark(name: string): string[] {
    if (!this.searchTextMark) return [name];
    const parts = name.split(new RegExp(`(${this.searchTextMark})`, 'gi'));
    return parts.filter(part => part.trim() !== "");
  }

  customSearch = (term: string, item: any) => {
    if (!term) {
      this.searchText = '';
      return true;
    }
    this.searchText = term;
    return item.name.toLowerCase().includes(term.toLowerCase());
  };

  customSearchMark = (term: string, item: any) => {
    if (!term) {
      this.searchTextMark = '';
      return true;
    }
    this.searchTextMark = term;
    return item.name.toLowerCase().includes(term.toLowerCase());
  };

  cleanMascoText(organization: any) {
    const { mascotText, city, state } = organization
    let stateName: string;
    if (!isNaN(state)) {
      let stateData = this.states.find((st: any) => st?.id === parseInt(state));
      stateName = stateData ? stateData.name : state;
    } else stateName = state;
    return (mascotText ? (mascotText + ' - ') : '') +
      (city ? city : '') +
      (stateName ? '(' + stateName + ')' : '');
  }

  onChangeOrganization(){
    this.organizationSelect.emit()
  }

  onChangeEmail(){
    this.emailSelect.emit()
  }

  onChangeMarket(){
    this.marketSelect.emit()
  }

  next(eve: any){
    this.nextEvent.emit(eve)
  }


}
